export const PAGINATION_LIMIT = 100;
//# sourceMappingURL=PaginationLimit.js.map